import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import IconButton from "@material-ui/core/IconButton";
import {ClickAwayListener} from "@material-ui/core";
import NGLContext from '../../NGLContext'
import TuneIcon from '@material-ui/icons/Tune'
import ExMenu from "./ExMenu";

// TODO: solve submenu bug
// https://codesandbox.io/s/l7wj3nv67z

const styles = theme => ({
    menuButton: {
        marginInline: '1em',
        outline: 'none !important',
        margin: '0.25em',
    },
});


@withStyles(styles)
class NGLSettingsMenu extends Component {

    static propTypes = {
        classes: PropTypes.object.isRequired,
        stage: PropTypes.object
    };

    constructor(props) {
        super(props);
        this.handleStageSettings = this.handleStageSettings.bind(this)
    }


    handleStageSettings = (parameter, value) => {
        this.props.stage.setParameters({[parameter]: value});
    };

    state = {
        menuItems: [
            {
                key: "1",
                caption: "Mouse Presets",
                onClick: () => {
                },
                selection: true,
                subMenuItems: [
                    {
                        key: "2",
                        caption: "Default",
                        value: "EnsemblePanel",
                        onClick: () => {
                            this.handleStageSettings("mousePreset","EnsemblePanel");
                        }
                    },
                    {
                        key: "3",
                        caption: "PyMol",
                        value: "pymol",
                        onClick: () => {this.handleStageSettings("mousePreset",'pymol')}
                    },
                    {
                        key: "4",
                        caption: "Coot",
                        value: "coot",
                        onClick: () => {this.handleStageSettings("mousePreset", 'coot')}
                    },
                ]
            },
            {
                key: "6",
                caption: "Quality",
                onClick: () => {
                },
                selection: true,
                subMenuItems: [
                    {
                        key: "7",
                        caption: "Auto",
                        value: "auto",
                        onClick: () => {this.handleStageSettings("quality", 'auto')}
                    },
                    {
                        key: "8",
                        caption: "Low",
                        value: "low",
                        onClick: () => {this.handleStageSettings("quality", 'low')}
                    },
                    {
                        key: "9",
                        caption: "Medium",
                        value: "medium",
                        onClick: () => {this.handleStageSettings("quality", 'medium')}
                    },
                    {
                        key: "10",
                        caption: "High",
                        value: "high",
                        onClick: () => {this.handleStageSettings("quality", 'high')}
                    }
                ]
            },
        ]
    };

    render() {
        const {classes} = this.props;

        return (
            <NGLContext.Consumer>
                {(contextNGL) => (
                    <React.Fragment>
                        <IconButton
                            className={classes.menuButton}
                            onClick={contextNGL.handleSettings}
                            color="inherit"
                            aria-haspopup="true"
                            aria-owns={contextNGL.SettingsMenu ? 'settings-menu' : undefined}
                            aria-label="Menu">
                            <TuneIcon/>
                        </IconButton>
                        <ClickAwayListener
                            onClickAway={contextNGL.closeSettings}>
                            <ExMenu
                                id="settings-menu"
                                anchorElement={contextNGL.SettingsMenu}
                                open={Boolean(contextNGL.SettingsMenu)}
                                onClose={contextNGL.closeSettings}
                                menuItems={this.state.menuItems}
                            >
                            </ExMenu>
                        </ClickAwayListener>
                    </React.Fragment>
                )}
            </NGLContext.Consumer>
        );
    }
}

export default NGLSettingsMenu;